import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { PricingValidationSchemaApi } from '../../models';

export const getValidationSchemas = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.BASE_PRICING}/validation-schemas/$get-all-active-schemas`,
  });
};

export const fetchValidationSchemas = async () => {
  const response: AxiosResponse<PricingValidationSchemaApi[]> = await getValidationSchemas();

  return response.data;
};
